import { ChangeDetectorRef, Component } from '@angular/core';
import { ContentService } from '../../spartacus/services/content.service';
import { Observable, combineLatest } from 'rxjs';
import { CmsComponentData } from '@spartacus/storefront';
import { CmsBannerComponent, OccConfig } from '@spartacus/core';
import { map, take } from 'rxjs/operators';
import { UserInfoService } from '../../spartacus/services/user-info.service';

@Component({
    selector: 'app-clinical-flucelvax-first',
    templateUrl: './clinical-flucelvax-first.component.html',
    styleUrls: ['./clinical-flucelvax-first.component.scss'],
    standalone: false
})
export class ClinicalFlucelvaxFirstComponent {
  fourthnode: Observable<any> = this.bannerComponent.data$;
  userLoggedIn: boolean = false;
  mergedObject1: any = [];
  study = [false,false];
  constructor(private accessService: ContentService, public bannerComponent: CmsComponentData<CmsBannerComponent>, protected config: OccConfig, private cd: ChangeDetectorRef, private userInfoService: UserInfoService) { }
   
  getImage(image: any): string {
    return this.config.backend?.occ?.baseUrl + image.desktop.url;
  }
  getMobileImage(image: any): string {
    return this.config.backend?.occ?.baseUrl + image.mobile.url;
  }
  openModal(): void {
    const modal = document.getElementById('childadult_abandonedPop');
    if (modal) {
      modal.style.display = 'block';
      document.body.classList.add('modal-open');
    }
  }
  closeModal(): void {
    const modal = document.getElementById('childadult_abandonedPop');
    if (modal) {
      modal.style.display = 'none';
      document.body.classList.remove('modal-open');
    }
  }

  toggleStudy(i:number){
    this.study[i]=!this.study[i]
    const body = document.querySelector('body') as HTMLElement;
    const stickyfooter = document.querySelector('.safety-info') as HTMLElement;
    const screenWidth = window.innerWidth;

    // Hide stickyfooter if any popup is open, show if all are closed
    if (screenWidth <= 992) {
      if (stickyfooter) {
        if (this.study.some(open => open)) {
          stickyfooter.style.display = 'none';
        } else {
          stickyfooter.style.display = 'block';
        }
      }
    } 
    if (screenWidth <= 992) {
      if (this.study[i]) {
        body.style.overflowY = 'hidden';
      } else {
        body.style.overflowY = 'auto';
      }
    } else {
      body.style.overflowY = 'auto';
    }
  }

  ngOnInit() {
    this.fourthnode.pipe(take(1)).subscribe(res => {
      this.clinicaltabs(res);
    });
    this.userInfoService.userLoggedIn$.subscribe(res=>{
    
      this.userLoggedIn = res;
      // if(this.userLoggedIn == true){
      //   this.renderer.setStyle(document.querySelector('.SideContent'),'display','block');
      // }
    })
  }

//   clinicaltabs(res: any) {
 
//   const tilesList = res.GraphChartList.split(" ");
//   this.accessService.opeffeaturedResources(tilesList).subscribe((res : any) => {
//    this.mergedObject1 = res.component;
//    console.log(this.mergedObject1);
//    this.cd.detectChanges;
//   });
// }
clinicaltabs(res: any) {
  const tilesList = res.GraphChartList.split(" ");

  this.accessService.opeffeaturedResources(tilesList).subscribe((res :any) => {
  
    
    // Check if apiRes.component is an array
    if (Array.isArray(res.component)) {
      // this.mergedObject1 = res.component;
      this.mergedObject1 = tilesList.map((uid:any) => res.component.find((c: any) => c.uid === uid)).filter((c:any) => !!c);
    } else if (res.component) {
      // Convert to array if it's not already
      //this.mergedObject1 = [res.component];
      this.mergedObject1 = tilesList.map((uid:any) => res.component.find((c: any) => c.uid === uid)).filter((c:any) => !!c);
    } else {
      // Ensure it's always an array
      this.mergedObject1 = [];
    }

 
    this.cd.detectChanges();  // Ensure detectChanges is called correctly
  });
}
}